import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import PartnershipChatScreen from "../../../../Components/ChatComponents/PartnershipChatScreen";

/**
 * Streamlined User/Brand Partnership Page
 * Now just a wrapper around the unified PartnershipChatScreen
 */
const PartnershipsPage = () => {
  const { partnershipId } = useParams();
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate("/collabs");
  };

  return (
    <PartnershipChatScreen
      partnershipId={partnershipId}
      onNavigateBack={handleNavigateBack}
    />
  );
};

export default PartnershipsPage;